/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminDashboardDto } from '../../models/admin-dashboard-dto';

export interface AdminControllerDashboard$Params {
}

export function adminControllerDashboard(http: HttpClient, rootUrl: string, params?: AdminControllerDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDashboardDto>> {
  const rb = new RequestBuilder(rootUrl, adminControllerDashboard.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminDashboardDto>;
    })
  );
}

adminControllerDashboard.PATH = '/admin/dashboard';
